/* eslint guard-for-in:0 */
/* global PortalL10n */

/**
 * PortalElementCarousel
 */

const PortalEvent = require('./PortalEvent')
const {log, error} = require('./PortalLogging')
const PortalApi = require('./PortalApi')
const PortalElementBase = require('./PortalElementBase')
const {l10n} = require('./PortalL10n')

const props = [
  'el'
]

module.exports = class PortalElementCarousel extends PortalElementBase {

  constructor(opts={}) {
    props.forEach(prop => {if (opts[prop] === undefined) throw new Error(`Missing required prop "${prop}" for PortalElementSearch`)})

    log("new PortalElementCarousel", opts)

    super(opts)
    Object.assign(this, {})
  }

  init() {
    let searchRequest = this.buildSearchRequest()
    this.api.search(searchRequest)
      .then(result => {
         if (typeof(result.objects) != 'undefined' && result.objects.length) {
           // Carousel-Bereich mit HTML-Code befüllen
           $(this.target).find('[data-function="ep-carousel"]').html(this.renderCarousel(result))
           // Carousel-Initilisierung über konfigurierte carouselInit-Funktion
           $(this.target).find('[data-function="ep-carousel"]').each((i,c) => {this.carouselInit(c)})
         }
      })
  }

  buildSearchRequest() {
    // Suchanfrage zusammenbauen
    let searchRequest = {offset: this.offset, limit: this.limit, "generate_rights": false, search: [], format: "long", sort: this.sort, objecttypes: this.objecttypes}

    // Objekttyp + Pool
    searchRequest.search.push(this.poolObjecttypeSearchPart())

    // Tags
    let searchRequestTags = {
      search: [{bool: "must", search: [{bool: "must", fields: ["_objecttype"], in: this.objecttypes, type: "in"},{bool: "must", fields: ["_tags._id"], in: this.tags, type: "in"}], type: "complex"}],
      type: "complex"
    }
    searchRequest.search.push(searchRequestTags)

    return searchRequest
  }
}




//////////////////
// WEBPACK FOOTER
// ./js/PortalElementCarousel.js
// module id = 21
// module chunks = 0